import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useThemeFeatureQuery = createQueryHook(ShopRendererThemesApiClient.getThemeFeature, {
  queryKey: ['themeFeature'],
})
